import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'required-field-dialog',
  templateUrl: './required-field-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RequiredFieldDialog implements OnInit {
  field: string;

  constructor(
    public dialogRef: MatDialogRef<RequiredFieldDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    if (this.data) {
      this.field = this.data.charAt(0).toUpperCase() + this.data.slice(1);
    }
  }
}
